import { Navigate, Outlet, useNavigate } from "react-router-dom";
import HeaderHost from "../Components/Host/HeaderHost";
import { restrictHostRoutes } from "../Components/Utility/CheckAuth";


function HostRoute() {
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();

  if (!token) {
    return <Navigate to="/" replace />;
  }

  const canAccess = restrictHostRoutes(navigate, 2);
  if (!canAccess) return <Navigate to="/" replace />;


  return (
    <>
      <HeaderHost />
      <div className="main-container pt-0">
        <div className="container">
          <Outlet />
        </div>
      </div>
      
    </>
  );
}

export default HostRoute;
